<template>
  <el-aside :class="{ iscollapse: isCollapse }">
    <!-- <el-affix> -->
    <el-menu class="menu" router unique-opened :collapse="isCollapse">
      <div class="menu_top">
        <template v-if="oem">
          <img
            class="logo"
            height="52"
            v-if="userInfo?.user?.oem_logo"
            :src="userInfo.user.oem_logo"
          />
          <span class="logo" v-else></span>
        </template>
        <template v-else>
          <img
            class="logo"
            src="@/assets/img/logo_collapse.png"
            v-if="isCollapse"
          />
          <img class="logo" src="@/assets/img/logo.png" v-else />
        </template>
        <img
          class="collapse hidden-xs-only"
          src="@/assets/img/collapse.svg"
          @click="isCollapse = !isCollapse"
        />
      </div>
      <el-scrollbar class="scorll_wrap" v-if="is_show">
        <template v-for="(menu, index) in menus" :key="index">
          <template v-if="menu.title">
            <el-menu-item :index="menu.link" v-if="menu.link">
              <!-- <iconpark-icon class="el-icon" :name="menu.icon"></iconpark-icon> -->
              <img class="el-icon" :src="menu.icon" />
              <span>{{ menu.title }}</span>
            </el-menu-item>
            <el-sub-menu :index="`${index}`" v-else>
              <template #title>
                <!-- <iconpark-icon class="el-icon" :name="menu.icon"></iconpark-icon> -->
                <img class="el-icon" :src="menu.icon" />
                <span>{{ menu.title }}</span>
                <em class="pro" v-if="menu.pro">{{ menu.pro }}</em>
              </template>
              <template v-for="(item, index) in menu.sub" :key="index">
                <el-menu-item v-if="item.title" :index="item.link">
                  <span>{{ item.title }}</span>
                  <em class="hot" v-if="item.hot">{{ item.hot }}</em>
                  <em class="offline" v-if="item.offline">
                    {{ item.offline }}
                  </em>
                </el-menu-item>
              </template>
            </el-sub-menu>
          </template>
        </template>
      </el-scrollbar>
    </el-menu>
    <!-- </el-affix> -->
  </el-aside>
</template>

<script setup>
import { ref, toRefs, computed } from 'vue'
import { useStore } from 'vuex'
import { is_oem, test_account_hidden } from '@/utils'

const store = useStore()
const { state } = store
const { userInfo } = toRefs(state)

const oem = computed(() => is_oem(userInfo.value))

const menus = computed(() => {
  const hidden_menu = (json) =>
    [5, 291, 546].includes(userInfo.value?.uid) ? json : {}
  const test_account_hidden_menu = (json) =>
    !test_account_hidden(userInfo.value) ? json : {}
  const menu_dsjxs_handle = (json) =>
    userInfo.value?.user?.menu_dsjxs ? json : {}
  const menu_douyin_ad_handle = (json) =>
    userInfo.value?.user?.menu_douyin_ad ? json : {}
  const menu_atjf_handle = (json) => (userInfo.value?.menu_atjf ? json : {})
  const menu_bzasone_rank_handle = (json) =>
    userInfo.value?.bzasone_rank ? json : {}
  const test_menu = (json) => ([1258].includes(userInfo.value?.id) ? json : {})
  return [
    {
      title: '看板',
      link: '/index',
      // icon: 'home-two',
      icon: require('@/assets/img/menu_icon1.svg'),
    },
    // {
    //   title: '企业号运营',
    //   pro: 'Old',
    //   // icon: 'zijinyunying',
    //   icon: require('@/assets/img/menu_icon2.svg'),
    //   sub: [
    //     {
    //       title: '代运营资料',
    //       link: '/operation_data',
    //     },
    //     {
    //       title: '企业号配置',
    //       link: '/site',
    //     },
    //     {
    //       title: '智能客服',
    //       link: '/reply',
    //     },
    //     {
    //       title: '行为营销',
    //       link: '/message_send',
    //     },
    //     {
    //       title: '自动化营销',
    //       link: '/enter_im',
    //     },
    //     {
    //       title: '合集管理',
    //       link: '/mix',
    //     },
    //     {
    //       title: '关键词排名',
    //       link: '/rank',
    //     },
    //   ],
    // },
    // {
    //   title: '互动获客',
    //   pro: 'Old',
    //   // icon: 'clue',
    //   icon: require('@/assets/img/menu_icon3.svg'),
    //   sub: [
    //     {
    //       title: '互动线索',
    //       link: '/leads_user_list',
    //     },
    //     // {
    //     //   title: '意向客户',
    //     //   link: '/enterprise_leads_user_list',
    //     // },
    //     {
    //       title: '私信线索',
    //       link: '/leads_action_user_list',
    //     },
    //     {
    //       title: '评论线索',
    //       link: '/enterprise_video_comment',
    //     },
    //     // {
    //     //   title: '智能获客',
    //     //   link: '/smart_customer_acquisition',
    //     // },
    //   ],
    // },
    {
      title: '账号运营',
      pro: 'New',
      icon: require('@/assets/img/menu_icon14.svg'),
      sub: [
        {
          title: '平台授权',
          link: '/auth',
        },
        {
          title: '意向用户',
          link: '/user_intention',
        },
        {
          title: '精准线索',
          link: '/user_list',
        },
        {
          title: '留资卡片',
          link: '/user_intention_card',
        },
        {
          title: '自动回复',
          link: '/user_intention_reply',
        },
        {
          title: '私信管理',
          link: '/user_intention_dialogu',
        },
        {
          title: '评论管理',
          link: '/video_item_comment',
        },
        // {
        //   title: '合集管理',
        //   link: '/mix',
        // },
        // {
        //   title: '关键词排名',
        //   link: '/rank',
        // },
        // menu_dsjxs_handle({
        //   title: '大数据线索',
        //   link: '/comment_manage',
        // }),
      ],
    },
    // {
    //   title: '视频管理',
    //   // icon: 'video-one',
    //   icon: require('@/assets/img/menu_icon4.svg'),
    //   sub: [
    //     {
    //       title: '智能云剪',
    //       link: '/video',
    //     },
    //     {
    //       title: '发布视频',
    //       link: '/video_release_manage',
    //     },
    //     {
    //       title: '视频管理',
    //       link: '/video_release_video_manage',
    //     },
    //   ],
    // },
    // {
    //   title: 'SEO管理',
    //   // icon: 'clue',
    //   icon: require('@/assets/img/menu_icon12.svg'),
    //   sub: [
    //     // {
    //     //   title: '新建素材',
    //     //   link: '/yjsc_add',
    //     // },
    //     // {
    //     //   title: '素材管理',
    //     //   link: '/yjsc_list',
    //     // },
    //   ],
    // },
    {
      title: '视频剪辑',
      pro: 'PRO',
      icon: require('@/assets/img/menu_icon8.svg'),
      sub: [
        // test_account_hidden_menu({
        //   title: '剪辑方式',
        //   link: '/video_pro_nav',
        // }),
        // {
        //   title: '脚本素材',
        //   link: '/material_class',
        // },
        {
          title: '脚本素材',
          link: '/material',
        },
        // {
        //   title: '创建智能云剪',
        //   link: '/video_pro_create',
        // },
        {
          title: '智能云剪',
          link: '/video_pro',
        },
        // {
        //   title: '创建批量云剪',
        //   link: '/video_batch_task_template',
        // },
        // {
        //   title: '批量云剪',
        //   link: '/video_batch_task',
        //   offline: '即将下线',
        // },
        // {
        //   title: '创建霸屏云剪',
        //   link: '/video_bp_task_create',
        // },
        // test_account_hidden_menu({
        //   title: '霸屏云剪',
        //   link: '/video_bp_task',
        //   offline: '即将下线',
        // }),
        // {
        //   title: '智能云剪',
        //   link: '/video_pro_task',
        // },
        // {
        //   title: 'AI云剪',
        //   link: '/video_ai_task',
        // },
        {
          title: '新版AI云剪',
          link: '/video_ai_task',
          hot: '推荐',
        },
        {
          title: '爆款云剪',
          link: '/hot_video',
        },
        {
          title: '爆款文案',
          link: '/copywriting_class',
        },
        {
          title: '七秒爆款',
          link: '/seven_seconds_list',
        },
        // {
        //   title: '数字人云剪',
        //   link: '/szr',
        // },
        // {
        //   title: 'AI剪辑 3.0',
        //   link: '/v3_ai_videoclip',
        // },
        {
          title: '视频库',
          link: '/video_pro_material_class',
        },
      ],
    },
    {
      title: '视频发布',
      pro: 'PRO',
      icon: require('@/assets/img/menu_icon9.svg'),
      sub: [
        // {
        //   title: '挂载设置',
        //   link: '/mount',
        // },
        // {
        //   title: '手动发布',
        //   link: '/video_pro_release_manual',
        // },
        // {
        //   title: '智能发布',
        //   link: '/video_pro_release_smart',
        // },
        // {
        //   title: '任务管理(旧)',
        //   link: '/video_pro_release_task',
        // },
        // {
        //   title: '发布明细(旧)',
        //   link: '/video_pro_release_detailed',
        // },
        // {
        //   title: '手动发布',
        //   link: '/video_new_release_manual',
        // },
        // {
        //   title: '智能发布',
        //   link: '/video_new_release_smart',
        // },
        // {
        //   title: '任务管理',
        //   link: '/video_new_release_task',
        // },
        {
          title: '抖音扫码发布',
          link: '/video_pro_release_schema',
        },
        {
          title: '单视频矩阵',
          link: '/v3_video_single_release',
          hot: '新版',
        },
        test_menu({
          title: 'Tiktok视频发布',
          link: '/tiktok_release',
        }),
        {
          title: '多视频矩阵',
          link: '/v3_video_release',
          hot: '新版',
        },
        {
          title: '探店码',
          link: '/tandianma_task',
          hot: '上新',
        },
        // {
        //   title: '发布明细',
        //   link: '/video_new_release_detailed',
        // },
      ],
    },
    {
      title: '抖音图文',
      pro: 'New',
      icon: require('@/assets/img/menu_icon15.svg'),
      sub: [
        // {
        //   title: '图文发布',
        //   link: '/image_text_task_editor',
        // },
        // {
        //   title: '任务管理',
        //   link: '/image_text_task_manage',
        // },
        {
          title: '超级图文',
          link: '/v2_image_text_task_manage',
          hot: '新版',
        },
        {
          title: '模板管理',
          link: '/v2_image_text_template_class',
          hot: '新版',
        },
      ],
    },
    // {
    //   title: '超级图文发布',
    //   icon: require('@/assets/img/menu_icon15.svg'),
    //   sub: [
    //     {
    //       title: '图文任务',
    //       link: '/v2_image_text_task_manage',
    //     },
    //     {
    //       title: '模板管理',
    //       link: '/v2_image_text_template_class',
    //     },
    //   ],
    // },
    menu_bzasone_rank_handle({
      title: '百智一体',
      icon: require('@/assets/img/menu_icon19.svg'),
      sub: [
        {
          title: '排名管理',
          link: '/bzasone_rank',
        },
        {
          title: '智能体管理',
          link: '/auth_znt',
        },
      ],
    }),
    menu_douyin_ad_handle({
      title: '信息流广告',
      // icon: 'ad-product',
      icon: require('@/assets/img/menu_icon10.svg'),
      sub: [
        {
          title: '数据概况',
          link: '/business_ad',
        },
        {
          title: '定向投放',
          link: '/business_ad_dingxiang',
        },
        {
          title: '消费报告',
          link: '/business_ad_bgbconsume',
        },
        {
          title: '投放数据',
          link: '/business_ad_bgbtime',
        },
        {
          title: '线索管理',
          link: '/business_ad_crm',
        },
        {
          title: '充值记录',
          link: '/business_ad_bgbreclist',
        },
        {
          title: '评论管理',
          link: '/business_ad_plcrm',
        },
        {
          title: '广告计划',
          link: '/business_ad_plan',
        },
      ],
    }),
    menu_douyin_ad_handle({
      title: '搜索广告',
      // icon: 'ad-product',
      icon: require('@/assets/img/menu_icon5.svg'),
      sub: [
        {
          title: '数据概况',
          link: '/task_crm_index',
        },
        {
          title: '搜索词报告',
          link: '/task_sokey',
        },
        {
          title: '线索管理',
          link: '/task_crm',
        },
        {
          title: '评论管理',
          link: '/task_plcrm',
        },
        {
          title: '消费报告',
          link: '/task_adv_finance',
        },
        {
          title: '充值记录',
          link: '/task_qcy_finance',
        },
        {
          title: '广告计划',
          link: '/task_plan',
        },
      ],
    }),
    menu_atjf_handle({
      title: '关键词计费',
      icon: require('@/assets/img/menu_icon11.svg'),
      sub: [
        {
          title: '关键词管理',
          link: '/douyin_rank_task_keyword',
        },
        {
          title: '消费记录',
          link: '/douyin_rank_task_data',
        },
        {
          title: '充值记录',
          link: '/douyin_rank_task_finance',
        },
      ],
    }),
    {
      title: '数据报表',
      icon: require('@/assets/img/menu_icon18.svg'),
      sub: [
        {
          title: '关键词排名',
          link: '/rank',
        },
        // {
        //   title: '运营报表',
        //   link: '/report_forms',
        // },
        {
          title: '企业号报表',
          link: '/douyin_data',
        },
      ],
    },
    // {
    //   title: '课程学习',
    //   // icon: 'classroom',
    //   icon: require('@/assets/img/menu_icon6.svg'),
    //   sub: [
    //     {
    //       title: '巨量课程',
    //       link: '/course',
    //     },
    //   ],
    // },
    {
      title: '运营指南',
      // icon: 'classroom',
      icon: require('@/assets/img/menu_icon13.svg'),
      sub: [
        {
          title: '账号升级',
          link: '/operate',
        },
        {
          title: '拍摄指引',
          link: '/guide',
        },
        {
          title: '爆款文案',
          link: '/writing',
        },
        // {
        //   title: '巨量课程',
        //   link: '/course',
        // },
        {
          title: '热门视频',
          link: '/pop_video',
        },
      ],
    },
    // {
    //   title: '矩阵直播',
    //   icon: require('@/assets/img/menu_icon16.svg'),
    //   sub: [
    //     {
    //       title: '直播记录',
    //       link: '/live_record',
    //     },
    //     {
    //       title: '弹幕推送',
    //       link: '/live_barrage',
    //     },
    //   ],
    // },
    {
      title: '应用工具',
      icon: require('@/assets/img/menu_icon17.svg'),
      sub: [
        {
          title: '挂载工具',
          link: '/mount',
        },
        {
          title: '应用工具',
          link: '/tool',
        },
      ],
    },
    {
      title: '系统设置',
      // icon: 'config',
      icon: require('@/assets/img/menu_icon7.svg'),
      sub: [
        // {
        //   title: '账号管理',
        //   link: '/data_center_account',
        // },
        // {
        //   title: '应用工具',
        //   link: '/tool',
        // },
        // {
        //   title: '消息推送',
        //   link: '/message_push',
        // },
        {
          title: '微信消息推送',
          link: '/message_push_wx',
        },
        {
          title: '关键词管理',
          link: '/keywords',
        },
        {
          title: '查询词设置',
          link: '/system_setting_topic',
        },
        // menu_dsjxs_handle({
        //   title: '线索词设置',
        //   link: '/system_setting_cluewords',
        // }),
        // hidden_menu({
        //   title: '达人监控',
        //   link: '/system_setting_user',
        // }),
        {
          title: '账号额度',
          link: '/account_limit',
        },
      ],
    },
  ]
})

const isCollapse = ref(false)
const location = ref(window.location)

const is_show = computed(() => userInfo.value?.id)
</script>

<style scoped lang="scss">
@import '@/assets/css/color.scss';

.menu_top {
  height: 80px;
  font-size: 20px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px 0;
  border-bottom: 0;
  .logo {
    margin-left: 19px;
  }
  .collapse {
    margin-right: 13px;
  }
}
.menu {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
  --el-menu-bg-color: #121f38;
  --el-menu-text-color: #fff;
  --el-menu-active-color: #fff;
  --el-menu-active-bg-color: #182640;
  --el-menu-item-font-size: 16px;
  .el-badge {
    top: 20px;
  }
  .el-icon {
    font-size: 24px;
  }
}
.el-aside {
  width: 281px;
  overflow: hidden;
  :deep(.el-affix--fixed),
  :deep(.el-affix) {
    width: 281px !important;
    /* height: 100%; */
  }
  &.iscollapse {
    width: 125px;
    .menu {
      --el-menu-item-font-size: 0;
    }
    .collapse {
      transform: rotate(180deg);
      transition: transform 0.3s;
    }
    :deep(.el-affix--fixed),
    :deep(.el-affix) {
      width: 124px !important;
    }
  }
}
@media screen and (max-width: 1440px) {
  .el-aside {
    width: 240px;
    :deep(.el-affix--fixed),
    :deep(.el-affix) {
      width: 240px !important;
    }
  }
}
.el-menu-item {
  /* border-radius: 28px; */
  margin-bottom: 11px;
  --el-menu-hover-bg-color: #182640;
  --el-menu-text-color: #fff;
  &.is-active {
    background-color: #195cff;
    font-weight: bold;
  }
  &:hover {
    color: #90c4ff;
  }
}
.el-sub-menu {
  margin-bottom: 11px;
  :deep(.el-sub-menu__title) {
    background-color: #182640 !important;
  }
  .pro {
    width: 40px;
    height: 20px;
    background: #f56541;
    border-radius: 2px;
    margin-left: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: bold;
  }
  .hot {
    height: 25px;
    padding: 0 5px;
    background: #de3f3f;
    border-radius: 5px;
    margin-left: 6px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    color: #fff;
  }
  .offline {
    @extend .hot;
    background-color: #103c7e;
  }
}
.scorll_wrap {
  /* height: calc(100vh - 80px); */
  padding: 15px 9px 15px 12px;
}
.collapse {
  cursor: pointer;
}
</style>

<style lang="scss">
.el-menu {
  &.el-menu--popup {
    min-width: 125px;
    --el-menu-bg-color: #182640;
  }
}
</style>
